import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stores-campaign-cutoff-list',
  templateUrl: './stores-campaign-cutoff-list.component.html',
  styleUrls: ['./stores-campaign-cutoff-list.component.scss']
})
export class StoresCampaignCutoffListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
  